module.exports = "<!-- Sidebar -->\r\n<app-header [tipoMenu]=\"tipoMenuValue\"></app-header>\r\n<app-grupo-perguntas></app-grupo-perguntas>\r\n            "